import { render, staticRenderFns } from "./Template5.vue?vue&type=template&id=6c00e406&scoped=true"
import script from "./Template5.vue?vue&type=script&lang=js"
export * from "./Template5.vue?vue&type=script&lang=js"
import style0 from "./Template5.vue?vue&type=style&index=0&id=6c00e406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c00e406",
  null
  
)

export default component.exports